import { useContext } from 'react';
import { Grid2 as Grid, Avatar, Box, Card, CardContent, CardHeader, ListItem, ListItemAvatar, ListItemText, Typography, Stack } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { blue, green } from '@mui/material/colors';
import GroupIcon from '@mui/icons-material/Group';
import CheckIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { FilersDataContext } from '../../../Filers';


const CommitteeInfo = (): JSX.Element => {

    const theme = useTheme();
    const filerDataContext = useContext(FilersDataContext);
    const currentFiler = filerDataContext.currentFilerPayload?.filer;
    const currentFilerPayload = filerDataContext.currentFilerPayload;

    return (
    <Grid size={{ xs: 12, md: 5.5 }} data-aos={'fade-up'} marginTop={2}>
        <Card 
            sx={{
              "&:hover": {
                boxShadow: "0 0 10px #ccc",
              },
              borderTop: `2px solid`,
              borderTopColor: green[700],
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              width: '100%',
              height: '100%',
            }}
            >
            <CardHeader
                avatar={
                <Avatar sx={{ bgcolor: blue[500] }} className="small-avatar">
                    <GroupIcon fontSize="small" />
                </Avatar>}
                padding={1}
                title={
                    <Typography
                    variant="h6">
                    Committee Information
                    </Typography>
                }                                                      
            />                                                   
             <CardContent className="card-content">
             <Grid container spacing={1}>
                  <Grid size={{ xs: 12, md: 7 }}>
                    <Stack spacing={0}>
                      <Typography component="i"  variant="subtitle1" color="text.secondary">Committee Name</Typography>
                      <Typography 
                        variant="subtitle1"
                        fontWeight={600}>
                         {currentFiler?.committeeName}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, md: 5}}>
                    <Stack spacing={0}>
                      <Typography component="i"  variant="subtitle1" color="text.secondary">Treasurer</Typography>
                        {
                            currentFiler?.treasurer.fullName?
                            <Typography 
                              variant="subtitle1">
                              {currentFiler?.treasurer.fullName}
                            </Typography>
                            :
                            <Stack direction="row" spacing={1}>
                              <ErrorOutlineIcon color="warning"/>
                              <Typography 
                                variant="subtitle1">
                                Treasurer Vacant
                              </Typography>
                            </Stack>
                        }
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, md: 7 }}>
                    <Stack spacing={0}>
                      <Typography component="i"  variant="subtitle1" color="text.secondary">Committee Address</Typography>
                      <Typography variant="subtitle1">
                        {currentFiler?.treasurer.fullAddress}
                      </Typography>
                    </Stack>
                  </Grid>
                  {
                    !currentFiler?.accountType.isBank && !currentFiler?.accountType.isSegregatedFund && !currentFiler?.accountType.isLocalFiler &&
                    <Grid size={{ xs: 12, md: 5 }}>
                    <Stack spacing={0}>
                      <Typography component="i"  variant="subtitle1" color="text.secondary">Treasurer Training</Typography>
                      <Stack direction="row" spacing={1}>
                        {
                          currentFilerPayload?.isMissingTreasurerTraining?
                            <ErrorOutlineIcon color="warning"/>
                          :
                          <CheckIcon color="success"/>
                        }
                        <Typography variant="subtitle1">
                          {currentFilerPayload?.treasurerTrainingStatus}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  }
                </Grid>               
            </CardContent>                                               
       </Card>
    </Grid>
    );
  };

export default CommitteeInfo;